import React from 'react'
import { render } from "react-dom"
import "./styles/app.scss"

import Header from "./components/Header"
import Explain from "./components/Explain"
import Learnings from "./components/Learnings"
import Methods from "./components/Methods"
import Reasons from "./components/Reasons"
import Contact from "./components/Contact"


export default function App() {
  return (
    <>
      <Header />
      <Explain />
      <Learnings />
      <Methods />
      <Reasons />
      <Contact />
    </>
  )
}


render(<App />, document.getElementById("root"))